import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export function useCleaningCompanies() {
  const [companies, setCompanies] = useState([]);
  const reload = useCallback(() => {
    api.get("/cleaning-companies").then((r) => setCompanies(r.data)).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { companies, names: companies.map((c) => c.name), reload };
}
